import { t } from "../../i18n";
import { Brain } from "lucide-react";
import type { MessageActivityEvent } from "@lumen/shared";

export function MemoryActivityCard({
  event,
}: {
  event: Extract<MessageActivityEvent, { type: "memory" }>;
}) {
  const count = event.added.length + event.forgotten.length;
  return (
    <details className="rounded-xl border border-violet-200 bg-violet-50/60 text-xs dark:border-violet-900/60 dark:bg-violet-950/20">
      <summary className="flex cursor-pointer list-none items-center gap-2 px-3 py-2 font-semibold text-violet-700 marker:content-none dark:text-violet-300">
        <Brain size={14} />{" "}
        {event.added.length && !event.forgotten.length
          ? t("Memory added")
          : t("Memory updated")}
        <span className="ml-auto rounded-full bg-violet-100 px-1.5 py-0.5 text-[10px] dark:bg-violet-900/50">
          {count}
        </span>
      </summary>
      <div className="space-y-2 border-t border-violet-200 p-3 leading-5 text-stone-600 dark:border-violet-900/60 dark:text-stone-300">
        {event.added.map((content) => (
          <div key={`added-${content}`}>
            <span className="mr-2 font-bold text-emerald-600">+</span>
            {content}
          </div>
        ))}
        {event.forgotten.map((content) => (
          <div key={`forgotten-${content}`}>
            <span className="mr-2 font-bold text-red-500">−</span>
            {content}
          </div>
        ))}
        <p className="pt-1 text-[11px] text-stone-400">
          {t("Manage memories in Profile settings.")}
        </p>
      </div>
    </details>
  );
}
